function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { useUIDSeed } from "react-uid";
import { IconDetailsGridCard, Section, SectionHeader } from "../../molecules";
export var IconDetailsGrid = function(_param) {
    var cards = _param.cards, className = _param.className, enableLines = _param.enableLines, darkbackground = _param.darkbackground, headerProps = _objectWithoutProperties(_param, [
        "cards",
        "className",
        "enableLines",
        "darkbackground"
    ]);
    var seed = useUIDSeed();
    var bgColor = darkbackground ? "offdefault" : "default";
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className,
        backgroundColor: bgColor
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-9 md:mb-12"
    }, /*#__PURE__*/ React.createElement(SectionHeader, _extends({
        variant: "mobile-centered"
    }, headerProps))), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 gap-9 sm:grid-cols-2 md:grid-cols-3 md:gap-y-12 md:gap-x-7"
    }, cards.map(function(card) {
        return /*#__PURE__*/ React.createElement(IconDetailsGridCard, _extends({
            key: seed(card)
        }, card));
    })));
};

//# sourceMappingURL=IconDetailsGrid.js.map